import React, { useState, useEffect } from "react";
import axios from "axios";
import { 
  HiOutlineShieldCheck, HiOutlineBadgeCheck, 
  HiOutlineSupport, HiOutlineClock, HiOutlineLibrary 
} from "react-icons/hi";
import { BiRefresh, BiCheckShield, BiWallet } from "react-icons/bi";
import { MdOutlineWaterDrop, MdOutlineElectricBolt } from "react-icons/md";
import { baseurl } from "../../baseurl";

// Import separate components
import ElectricityCheck from "./ElectricityCheck";
import WaterCheck from "./WaterCheck";

const BillPayment = () => {
  const [activeTab, setActiveTab] = useState("electricity");
  const [walletBalance, setWalletBalance] = useState(0);
  const [loading, setLoading] = useState(false);
  const guestUserId = localStorage.getItem('guestUserId');

  const fetchBalance = () => {
    if (guestUserId) {
      axios.get(`${baseurl}/getWalletBalance/${guestUserId}`)
        .then(res => setWalletBalance(parseFloat(res.data.balance) || 0))
        .catch(err => console.error("Wallet Error", err));
    }
  };

  useEffect(() => {
    fetchBalance();
  }, [guestUserId]);

  return (
    <div className="bill-payment-wrapper">
      <div className="container py-5">
        <div className="row g-4 justify-content-center align-items-start">
          
          {/* --- LEFT COLUMN: COMPACT BILLING FORM --- */}
          <div className="col-12 col-md-6 col-lg-5">
            <div className="billing-main-card shadow-lg border-0 overflow-hidden">
              
              {/* COMPACT WALLET BAR INSET */}
              <div className="compact-wallet-bar d-flex justify-content-between align-items-center px-4 py-3">
                <div className="d-flex align-items-center">
                  <div className="wallet-dot me-2"></div>
                  <span className="small opacity-75 fw-bold text-white uppercase">Wallet: </span>
                  <span className="ms-2 fw-bold text-white">₹{walletBalance.toLocaleString('en-IN')}</span>
                </div>
                <div className="d-flex gap-2">
                   <button className="icon-action-btn" onClick={fetchBalance} title="Refresh">
                    <BiRefresh size={18} />
                  </button>
                  <button className="add-money-small" onClick={() => window.location.href = "/wallet"}>
                    + Add
                  </button>
                </div>
              </div>

              {/* TAB NAVIGATION */}
              <div className="tab-control-group">
                <button 
                  className={`tab-btn ${activeTab === 'electricity' ? 'active' : ''}`}
                  onClick={() => setActiveTab('electricity')}
                >
                  <MdOutlineElectricBolt className="tab-icon" />
                  <span>Electricity</span>
                </button>
                <button 
                  className={`tab-btn ${activeTab === 'water' ? 'active' : ''}`}
                  onClick={() => setActiveTab('water')}
                >
                  <MdOutlineWaterDrop className="tab-icon" />
                  <span>Water</span>
                </button>
              </div>

              {/* FORM BODY */}
              <div className="billing-card-body p-4">
                <div className="animate-fade-in">
                  {activeTab === "electricity" ? (
                    <ElectricityCheck loading={loading} />
                  ) : (
                    <WaterCheck loading={loading} />
                  )}

                  {/* <button className="theme-submit-btn w-100 shadow mt-3">
                    {loading ? (
                      <span className="spinner-border spinner-border-sm me-2"></span>
                    ) : "Fetch Bill Details"}
                  </button> */}
                </div>
                
                <div className="security-footer mt-4 pt-3 border-top d-flex align-items-center justify-content-center">
                  <HiOutlineShieldCheck className="text-success me-2" size={18} />
                  <span className="x-small fw-bold text-muted">SECURE BBPS GATEWAY</span>
                </div>
              </div>
            </div>
          </div>

          {/* --- RIGHT COLUMN: INFO PANEL --- */}
          <div className="col-12 col-md-6 col-lg-5">
            <div className="info-panel-content ps-lg-4">
              <h2 className="fw-bold theme-text-primary mb-3">Instant Bill Pay</h2>
              <p className="text-muted mb-4 small">Experience seamless utility payments with India's most trusted gateway.</p>
              
              <div className="benefit-row row g-3 mb-4">
                <div className="col-6">
                  <div className="compact-feature p-3 rounded-3 bg-white border">
                    <HiOutlineBadgeCheck className="theme-text-primary mb-2" size={24} />
                    <h6 className="small fw-bold mb-1">Instant</h6>
                    <p className="x-small text-muted mb-0">Direct settlement</p>
                  </div>
                </div>
                <div className="col-6">
                  <div className="compact-feature p-3 rounded-3 bg-white border">
                    <BiCheckShield className="text-success mb-2" size={24} />
                    <h6 className="small fw-bold mb-1">Secure</h6>
                    <p className="x-small text-muted mb-0">256-bit AES Pay</p>
                  </div>
                </div>
              </div>

              <div className="promo-tag p-3 rounded-3 d-flex align-items-center shadow-sm">
                <div className="promo-icon me-3">🎁</div>
                <div>
                  <h6 className="small fw-bold mb-0">Zero Service Fee</h6>
                  <p className="x-small text-muted mb-0">No extra charges on wallet payments.</p>
                </div>
              </div>

              <div className="trust-badges d-flex justify-content-between mt-5 pt-3 border-top opacity-50">
                <div className="badge-item"><HiOutlineSupport size={18}/><br/><span className="x-small">Support</span></div>
                <div className="badge-item"><HiOutlineClock size={18}/><br/><span className="x-small">Real-time</span></div>
                <div className="badge-item"><HiOutlineLibrary size={18}/><br/><span className="x-small">Govt. Appr.</span></div>
              </div>
            </div>
          </div>

        </div>
      </div>
      
      <style>{`
        :root {
          --theme-primary: #166070;
          --theme-gradient: linear-gradient(135deg, #166070 0%, #2a889d 100%);
          --theme-bg: #f4f7f8;
        }

        .bill-payment-wrapper { background: var(--theme-bg); min-height: 100vh; margin-top: 80px; }
        
        /* Compact Wallet Bar */
        .compact-wallet-bar { background: var(--theme-gradient); border-bottom: 1px solid rgba(255,255,255,0.1); }
        .wallet-dot { width: 8px; height: 8px; background: #4dfd9b; border-radius: 50%; box-shadow: 0 0 10px #4dfd9b; }
        .icon-action-btn { background: rgba(255,255,255,0.15); border: none; color: white; border-radius: 6px; padding: 2px 6px; transition: 0.3s; }
        .icon-action-btn:hover { background: rgba(255,255,255,0.3); }
        .add-money-small { background: white; color: var(--theme-primary); border: none; padding: 2px 12px; border-radius: 4px; font-size: 0.75rem; font-weight: 700; }

        /* Billing Card */
        .billing-main-card { background: white; border-radius: 16px;min-height: 100vh; }
        .tab-control-group { display: flex; background: #f8f9fa; }
        .tab-btn { 
          flex: 1; padding: 14px; border: none; background: transparent; 
          display: flex; align-items: center; justify-content: center; gap: 8px;
          color: #888; font-size: 0.9rem; font-weight: 600; transition: 0.3s;
          border-bottom: 2px solid transparent;
        }
        .tab-btn.active { 
          background: white; color: var(--theme-primary); 
          border-bottom: 2px solid var(--theme-primary);
        }
        
        .theme-submit-btn {
          background: var(--theme-gradient); color: white; border: none;
          padding: 14px; border-radius: 10px; font-weight: 700; transition: 0.3s;
        }
        .theme-submit-btn:hover { filter: brightness(1.1); transform: translateY(-1px); }

        /* Utils */
        .x-small { font-size: 11px; }
        .promo-tag { background: white; border-left: 4px solid #4dfd9b; }
        .theme-text-primary { color: var(--theme-primary); }
        
        @keyframes fadeIn { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: translateY(0); } }
        .animate-fade-in { animation: fadeIn 0.4s ease-out; }

        @media (max-width: 768px) {
          .bill-payment-wrapper { margin-top: 20px; }
          .info-panel-content { text-align: center; margin-top: 40px; }
          .benefit-row { text-align: left; }
        }
      `}</style>
    </div>
  );
};

export default BillPayment;